import { FormValidationRule } from "../types";
import * as ibantools from "ibantools";

const isValidIban: FormValidationRule = (c, v) => {
    let valid = true;
    let invalidMessage = "You must enter a valid IBAN.";
    if (c.type === "iban" && v) {
        const iban = v.toUpperCase().replace(/\s/g,'');
        if (!ibantools.isValidIBAN(iban)) {
            valid = false;
        } else {
            const code = iban.substring(0, 2);
            if (c.field_boi_tab_sepa_iban) {
                if (!ibantools.isSEPACountry(code) && code !== "VA" && code !== "va") {
                    valid = false;
                    invalidMessage = "You must enter a valid SEPA IBAN.";
                }
            } else {
                if (!c.field_boi_tab_international_iban) {
                    if (code !== "IE" && code !== "ie") {
                        valid = false;
                        invalidMessage = "You must enter a valid Irish IBAN."
                    }
                }
            }
            if (c.field_boi_tab_boi_iban && !v.includes("BOFI")) {
                valid = false;
                invalidMessage = "You must enter a valid Bank of Ireland IBAN.";
            }
        }
    }
    
    return [valid, c.errorMessage || invalidMessage];
};

export default isValidIban;